import React, { useState } from "react"
import { Link } from "gatsby"

// Matches JOURNAL_ENABLED in gatsby-node.js. Switch to true to put the
// Journal link back in the nav once the journal is publishing again.
const JOURNAL_ENABLED = false

const links = [
  { label: "Work", to: "/" },
  { label: "Services", to: "/services/" },
  ...(JOURNAL_ENABLED ? [{ label: "Journal", to: "/journal/" }] : []),
  { label: "About", to: "/about/" },
  { label: "Contact", to: "/contact/" },
]

export default function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <span className="brand__name">Greg Woodward</span>
          <span className="brand__role">Photographer / Director</span>
        </Link>
        <nav className="desktop-nav" aria-label="Primary navigation">
          {links.map(link => (
            <Link
              key={link.to}
              to={link.to}
              activeClassName="is-active"
              partiallyActive={link.to !== "/"}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <button
          className="menu-toggle"
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span>{open ? "Close" : "Menu"}</span>
          <span className="menu-toggle__mark" aria-hidden="true">
            {open ? "×" : "↘"}
          </span>
        </button>
      </div>
      {open && (
        <nav className="mobile-nav" aria-label="Mobile navigation">
          <span className="mobile-nav__eyebrow">Selected work / 2026</span>
          {links.map((link, index) => (
            <Link
              key={link.to}
              to={link.to}
              activeClassName="is-active"
              partiallyActive={link.to !== "/"}
              onClick={() => setOpen(false)}
            >
              <span>0{index + 1}</span>
              {link.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  )
}
